import { Controller } from "@hotwired/stimulus"

// Filters the arena Models index by name (substring match against
// data-name) and by mode (data-modes is a space-separated list of
// competition_type slugs). Both filters AND together.
export default class extends Controller<HTMLElement> {
  static targets = ["input", "modeButton", "tile", "count", "empty"]
  static values = { mode: String }

  declare readonly inputTarget: HTMLInputElement
  declare readonly modeButtonTargets: HTMLElement[]
  declare readonly tileTargets: HTMLElement[]
  declare readonly countTarget: HTMLElement
  declare readonly emptyTarget: HTMLElement
  declare modeValue: string
  declare readonly hasCountTarget: boolean
  declare readonly hasEmptyTarget: boolean

  connect() {
    this.apply()
  }

  onInput() {
    this.apply()
  }

  selectMode(event: Event) {
    const btn = event.currentTarget as HTMLElement
    this.modeValue = btn.dataset.mode || ""
  }

  modeValueChanged() {
    this.updateModeButtons()
    this.apply()
  }

  clear() {
    this.inputTarget.value = ""
    this.modeValue = ""
    this.apply()
  }

  private updateModeButtons() {
    for (const btn of this.modeButtonTargets) {
      const active = (btn.dataset.mode || "") === this.modeValue
      btn.dataset.active = active ? "true" : "false"
    }
  }

  private apply() {
    const q = (this.inputTarget?.value || "").trim().toLowerCase()
    const mode = this.modeValue || ""
    let shown = 0

    for (const tile of this.tileTargets) {
      const name = (tile.dataset.name || "").toLowerCase()
      const modes = (tile.dataset.modes || "").split(/\s+/)
      const nameOk = !q || name.includes(q)
      const modeOk = !mode || modes.includes(mode)
      const visible = nameOk && modeOk
      tile.classList.toggle("hidden", !visible)
      if (visible) shown++
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = String(shown)
    }
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", shown > 0)
    }
  }
}
